import React, { useEffect, useState } from "react";
import { Form, Button } from "semantic-ui-react";
import { Navigate, useNavigate } from "react-router-dom";
import "../css/Register.css";
import "../css/UniversityInfo.css";

export default function UniversityInfo() {
    const [descriptionUni, setDescription] = useState();
    const [addressUni, setAddress] = useState();
    const [no_studentUni, setNo_studentUni] = useState();
    const [picturesUni, setPicturesUni] = useState();
    let navigate = useNavigate();

    const handleDescription = (e) => {
        setDescription(e.target.value);
        console.log(descriptionUni);
    };

    const handleAddress = (e) => {
        setAddress(e.target.value);
        console.log(addressUni);
    };

    const handleNo_student = (e) => {
        setNo_studentUni(e.target.value);
        console.log(no_studentUni);
    };

    const handlePictures = (e) => {
        setPicturesUni(e.target.value);
        console.log(picturesUni);
    };

    const redirectLogin = () => {
        navigate("/");
    };

    // edit university
    async function handleEditUni() {
        try {
            let info = {
                userid: localStorage.getItem("userid"),
                description: descriptionUni,
                location: addressUni,
                no_student: no_studentUni
            };

            let jsonObj = JSON.stringify(info);

            const response = await fetch(
                "https://student-org-events.herokuapp.com/PHP/editUniversity.php",
                {
                    method: "POST",
                    body: jsonObj,
                    header: { "Content-Type": "application/json" },
                }
            );

            let res = await response.json();
            console.log("This is the response error: " + res.error);

            if (res.error === "Updated successfully") {
                console.log("Successfully updated university");
                redirectLogin();
            } else {
                console.log("Unsuccessfully updated university");
            }
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <div className="uniinfo">
            <div className="ui center aligned padded grid register-box">
                <div className="row">
                    <div className="register-blue-sidebar column five wide">
                        <h2 className="register-app-title">Student Events</h2>
                    </div>
                    <div className="uniinfo-box column eleven wide">
                        <div>
                            <h1 className="uniinfo-header">Tell Us About Your University</h1>
                            <Form onSubmit={handleEditUni}>
                                <div className="uniinfo-input">
                                    <Form.TextArea
                                        fluid
                                        placeholder="Description of Your University"
                                        required
                                        onChange={handleDescription}
                                    />
                                </div>
                                <div className="uniinfo-input">
                                    <Form.Input
                                        fluid
                                        placeholder="University Address"
                                        required
                                        onChange={handleAddress}
                                    />
                                </div>
                                <div className="uniinfo-input">
                                    <Form.Input
                                        fluid
                                        placeholder="Number of Students"
                                        required
                                        onChange={handleNo_student}
                                    />
                                </div>
                                <div className="uniinfo-button">
                                    <Button className="uniinfo-btn">
                                        FINISH
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
